/*------------------------------------------------
// File Name:PDM_MA_Schd.js
// File Description:PDM_MA_Schd store方法
// Author:zxl
// Create Time:2023/06/06 11:19:48
//------------------------------------------------*/

import {
    GetPDM_MA_SchdList,
    GetPDM_MA_SchdListByPage,
    GetPDM_MA_SchdEntity,
    CreatePDM_MA_SchdEntity,
    UpdatePDM_MA_SchdEntity,
    DeletePDM_MA_SchdEntity,
} from '@/api/pdm/ma/maSchd'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmMaSchd = {
    namespaced: true,
    state: {
        PdmMaSchdList: [],
        PdmMaSchdListLoading: false,
        PdmMaSchdEntity: null,
        PdmMaSchdShowDlg: false,
		PaiBanData:[],
        Years: null,//年
        Month: null,//月
    },
    mutations: {
		setPaiBanData(state, dataList) {
            state.PaiBanData = [...dataList]
        },
        setYears(state, visible) {
            state.Years = visible
        },
        setMonth(state, visible) {
            state.Month = visible
        },
        setPdmMaSchdList(state, dataList) {
            state.PdmMaSchdList = [...dataList]
        },
        setPdmMaSchdListLoading(state, visible) {
            state.PdmMaSchdListLoading = visible
        },
        setPdmMaSchdShowDlg(state, visible) {
            state.PdmMaSchdShowDlg = visible
        },
        setPdmMaSchdEntity(state, entity) {
            state.PdmMaSchdEntity = entity
        },
    },
    actions: {
        //创建预约排班对象
        actCreatePdmMaSchd({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_MA_SchdEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaSchdEntity', res.Data)
                        commit('setPdmMaSchdShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约排班对象
        actGetPdmMaSchdEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaSchdListLoading', true)
                GetPDM_MA_SchdEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaSchdEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaSchdListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约排班列表
        actGetPdmMaSchdList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaSchdListLoading', true)
                GetPDM_MA_SchdList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaSchdList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaSchdListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载预约排班列表
        actGetPdmMaSchdListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaSchdListLoading', true)
                GetPDM_MA_SchdListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaSchdList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaSchdListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存预约排班信息
        actUpdatePdmMaSchd({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_MA_SchdEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaSchdShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Schd
        actEditPdmMaSchdData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmMaSchdID : entity.PdmMaSchdID
                }
                GetPDM_MA_SchdEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmMaSchdEntity', res.Data)
                        commit('setPdmMaSchdShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Schd ,传对象过来
        actEditPdmMaSchd({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmMaSchdEntity', entity)
                commit('setPdmMaSchdShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_MA_Schd
        actDeletePdmMaSchd({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前预约排班？").onOk(() => {
                    DeletePDM_MA_SchdEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmMaSchdShowDlg', false)
                           
                            msg.success("删除预约排班成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除预约排班失败，原因:" + res.Message)
                            //msg.success("删除预约排班失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


